import { Button, Tooltip, Divider, Modal, Spin, message } from 'antd';
import * as PANOLENS from 'panolens';
import { SphereBufferGeometry } from 'three';
import { getAlbumList, deleteAlbum, createShare } from '@/api/hdd/album';
import dayjs from 'dayjs';
import { hddDownload, hddRenderSameAngle } from '&/utils/common';
import SvgIcon from '&/components/SvgIcon';
import UpgradeModal from '@/components/PhotoAlbumItem/UpgradeModal';
import ShareModal from '@/components/PhotoAlbumItem/ShareModal';
import { LeftOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import Empty from '@/components/PhotoAlbumItem/Empty';
import { useRouterTarget } from '&/utils/customHooks';
import { useEffect } from 'react';
import Panorama from '&/components/Panorama';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './panoramaDetail.scss';

export default function PanoramaDetail(props) {
    const schemeId =
        new URLSearchParams(window.location.search).get('schemeId') || 881;
    const renderId = new URLSearchParams(window.location.search).get('id');

    const targetPage = useRouterTarget();

    usePreventDefault();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [shareModalOpen, setShareModalOpen] = useState(false);

    const [sliderList, setSliderList] = useState([]);

    const [loading, setLoading] = useState(false);

    const [tipPosition, setTipPosition] = useState([]);

    const renderAtAngle = () => {
        let params = { camera: tipPosition[active]?.camera, type: 1 };
        hddRenderSameAngle(params);
    };

    const upgradeHandle = () => {
        if (tipPosition?.[active]?.resolution === '8k') {
            return message.warning('该图片已是最高分辨率了');
        }
        setIsModalOpen(true);
    };

    const deleteFn = () => {
        console.log('delete');
        Modal.confirm({
            title: null,
            icon: null,
            content: `确认删除吗`,
            okText: '确认',
            cancelText: '取消',
            onOk: close => {
                deleteAlbum({ renderIds: [tipPosition[active].id] }).then(
                    () => {
                        close();

                        setSliderList(prev => {
                            prev.splice(active, 1);
                            return [...prev];
                        });

                        setActive(0);

                        setTipPosition(prev => {
                            prev.splice(active, 1);
                            return [...prev];
                        });
                    }
                );
            },
            onCancel: close => {
                close();
            },
        });
    };

    const [active, setActive] = useState(-1);

    const handleNavClick = (imgProps, index) => {
        setActive(index);
    };

    useEffect(() => {
        setLoading(true);
        getAlbumList({ hDocId: schemeId, status: 2, renderType: 1 })
            .then(res => {
                let list = res.data.list;
                list.map(item => {
                    console.log('item.renderUrl', item.renderUrl);
                    const panorama = new PANOLENS.ImagePanorama(
                        item.renderUrl,
                        new SphereBufferGeometry(5000, 128, 108)
                    );
                    item.panorama = panorama;
                    return item;
                });
                setSliderList([...list]);
                setTipPosition(list);
                console.log('list', list);
                let index = list.findIndex(item => item.id === renderId);
                if (index === -1) {
                    setActive(0);
                    return;
                }
                setActive(index);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const onGoBack = () => {
        props.history.goBack();
    };

    const handleEdit = () => {
        targetPage({
            pathname: '/hdd/panoramaEdit',
            search: {
                id: tipPosition[active].id,
                schemeId,
                type: 'panorama',
            },
        });
    };

    const handleCreatePanorama = () => {
        console.log('handleCreatePanorama');
        try {
            window.external.DispatchFun('Atlas', 'CratePanoramaImage', '');
        } catch (e) {}
    };

    const handleOpenBrowser = () => {
        createShare({
            renderId: tipPosition[active]?.id,
            type: 1,
        }).then(res => {
            console.log(res);
            if (!res.data) return;
            let url =
                window.location.host +
                '/hdd/panoramaShare?shareCode=' +
                res.data.shareCode +
                '&panorama=0';
            console.log('url', url);
            try {
                window.external.DispatchFun('Atlas', 'OpenBrowser', url);
            } catch (error) {
                Promise.reject(error);
                console.log(error);
            }
        });
    };

    return (
        <Spin spinning={loading}>
            <div className="photo-panorama-detail">
                <div className="header">
                    <div onClick={onGoBack}>
                        <LeftOutlined /> 返回图册
                    </div>
                    <div className="title">{tipPosition?.[active]?.title}</div>
                </div>
                <div className="content">
                    <div className="left-preview">
                        {!!tipPosition.length && (
                            <>
                                <div className=" info-tip">
                                    {tipPosition?.[active]?.resolution}{' '}
                                    <Divider type="vertical" />{' '}
                                    {/* {tipPosition?.[active]?.pixelAspect}
                                    <Divider type="vertical" />{' '} */}
                                    {tipPosition?.[active]?.roomType}{' '}
                                    <Divider type="vertical" />{' '}
                                    {dayjs
                                        .unix(tipPosition?.[active]?.updateDate)
                                        ?.format('YYYY-MM-DD HH:mm:ss')}
                                </div>
                                <Panorama
                                    sliderList={sliderList}
                                    tipPosition={tipPosition}
                                    showSpot={false}
                                    current={active}
                                    setCurrent={setActive}
                                    showAllHouse={false}
                                    noZoom
                                />
                            </>
                        )}
                        {!tipPosition.length && (
                            <Empty
                                tip="暂无全景图，请先渲染"
                                btnWord="创建全景图"
                                handleCreate={handleCreatePanorama}
                            />
                        )}
                    </div>
                    <div className="right-nav">
                        {sliderList.map((v, index) => (
                            <div
                                className={`nav-wrap ${
                                    index === active ? 'active' : ''
                                } `}
                                key={index}
                                onClick={() => handleNavClick(v, index)}>
                                <img src={v.coverImageUrl}></img>
                                <div className="img-name">{v.title}</div>
                            </div>
                        ))}
                    </div>
                </div>
                <div
                    className="footer"
                    style={{
                        visibility: tipPosition.length ? 'visible' : 'hidden',
                    }}>
                    <Button
                        type="text"
                        className="item"
                        key={0}
                        onClick={renderAtAngle}>
                        <SvgIcon iconName="Icon-Camera" />
                        <span className="word">渲染同角度</span>
                    </Button>
                    <Button
                        type="text"
                        key={1}
                        onClick={() =>
                            hddDownload([
                                {
                                    picturepath: tipPosition[active].renderUrl,
                                    picturename: tipPosition[active].title,
                                },
                            ])
                        }>
                        <SvgIcon iconName="Icon-Download1" />
                        <span className="word">下载</span>
                    </Button>
                    <Button type="text" key={2} onClick={upgradeHandle}>
                        <SvgIcon iconName="Icon-Upgrade" />
                        <span className="word">升级分辨率 </span>
                        <Tooltip
                            placement="top"
                            title={'升级后，原图将被替换不可恢复'}>
                            <QuestionCircleOutlined />
                        </Tooltip>
                    </Button>
                    <Button
                        type="text"
                        className="item"
                        key={3}
                        onClick={handleOpenBrowser}>
                        <SvgIcon iconName="Icon-Broser" />
                        <span className="word">浏览器打开</span>
                    </Button>
                    <Button
                        type="text"
                        className="item"
                        key={4}
                        onClick={handleEdit}>
                        <SvgIcon iconName="Icon-Edit-p " />
                        <span className="word">全景图编辑 </span>
                    </Button>
                    <Button type="text" key={5} onClick={deleteFn}>
                        <SvgIcon iconName="Icon-Trash" />
                        <span className="word">删除</span>
                    </Button>
                </div>

                <UpgradeModal
                    isModalOpen={isModalOpen}
                    itemType={'panorama'}
                    {...tipPosition?.[active]}
                    getCurList={onGoBack}
                    setIsModalOpen={setIsModalOpen}
                />

                <ShareModal
                    isModalOpen={shareModalOpen}
                    setIsModalOpen={setShareModalOpen}
                />
            </div>
        </Spin>
    );
}
